"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      title: ''
    };
  },
  computed: {
    isInIframe: function isInIframe() {
      return window.self !== window.top;
    }
  },
  methods: {
    toIndex: function toIndex() {
      this.$emit("toIndex");
    }
  }
};